<template>
    <div>
        <static-loading-indicator-icon></static-loading-indicator-icon>
        <div class="row equal">
            <div class="col-md-6 col-12 mb-5"  v-for="post in posts" :key="post.id">
                <blog-post-card :post="post"></blog-post-card>
            </div>
        </div>
        <pagination :data="paginationData" @pagination-change-page="getBlogPosts"></pagination>
    </div>
</template>

<script>
import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";
import BlogRepository from "../../repositories/Blog/BlogRepository";
import BlogPostCard from "./BlogPostCard";

export default {
    name: "Blog",
    components: {BlogPostCard, StaticLoadingIndicatorIcon},
    data: () => ({
        paginationData: {}
    }),
    mounted() {
        this.getBlogPosts();
    },
    methods: {
        getBlogPosts(page = 1) {
            BlogRepository.getBlogPosts(page).then(res => {
                this.paginationData = res.data;
            });
        }
    },
    computed: {
        posts() {
            return this.paginationData.data;
        }
    }
}
</script>

<style scoped>

</style>
